export class CreateTaskCommentResponseDto {
    result: boolean;

    constructor(result: boolean) {

        this.result = result;
    }
}
